import $ from 'jquery';
import Framework from 'framework';
import constants from 'lib/constants';
import _ from 'ext:lodash';
import authUtils from "lib/auth-utils";

function updateLoginLinks(urlStoreData) {
	const useB2C = authUtils.isFeatureFlagEnabled('useB2C');

	const loginLinks = $('.js-login-link');
	loginLinks.each((index, link) => {
		const $link = $(link);
		if (useB2C && window.ef.b2cStore) {
			$link.css({cursor: 'pointer'});
			$link.on('click', async () => {
				await window.ef.b2cStore.login();
			});
		} else {
			const linkHref = _.result(urlStoreData.globalPageDrivers, constants.loginResoucePageDriver);
			$link.attr('href', linkHref);
		}
	});
}

export default class LoginLinks {
	constructor(UrlStore) {
		this.UrlStore = UrlStore;
	}

	initialize() {
		if(_.isUndefined(this.UrlStore)) {
			console.error('login-link component failed to initialize UrlStore dependency');
		}

		var urlStoreData = this.UrlStore.getInitialData();
		updateLoginLinks(urlStoreData);

		this.UrlStore.listen((urlStoreDataListen) => {
			updateLoginLinks(urlStoreDataListen);
		});
	}
}
